export default {"src":"/_next/static/media/oral.253b99b8.svg","height":746,"width":851};